import { createBrowserRouter } from "react-router-dom";
import { PortfolioPage } from "../pages/PortfolioPage";
import { NotFoundPage } from "../pages/NotFoundPage";

export const router = createBrowserRouter([
  { path: "/", element: <PortfolioPage /> },
  { path: "*", element: <NotFoundPage /> },
]);
